import memoize from 'lodash/memoize'

export const hasWebpSupport = memoize(() => {
  try {
    return document.createElement('canvas').toDataURL('image/webp').startsWith('data:image/webp')
  } catch {
    return false
  }
})
